<div *ngIf="displayedColumns">
  <div class="table-container">
    <ng-container *ngIf="!expandable; then tableNormal; else tableExpandable"></ng-container>
  </div> 
  <ng-container *ngIf="filterServer">
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]" (page)="filter()"></mat-paginator>
  </ng-container>
  <ng-container *ngIf="!filterServer">
    <mat-paginator [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]" [ngClass]="{'mb-16 h-40 table-bordered': paginatorBorder}"></mat-paginator>
  </ng-container>
  
  
</div>


<!-- Normal Table -->
<ng-template #tableNormal>

  <ng-container *ngIf="!isFormArray(); else formTable">
      <table mat-table
        [dataSource]="dataSource && dataSource.data.length > 0 && dataSource.filteredData.length > 0 ? dataSource : emptyData"
        matSort class="table table-bordered display"
        [ngClass]="{'mb-0': paginatorBorder}">
      
        <!-- CheckBox Columns -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox #headerCheckbox
              *ngIf="showSelectAllCheckbox"
              (change)="$event ? masterToggle($event) : null"
              [indeterminate]="alreadySelectedRows.alreadySelectedKeys?.length > 0 && alreadySelectedRows.alreadySelectedKeys?.length != paginator?.length" 
              [disabled]="!allowEdit && !allowEditCheckBox">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row" class="padding-left-8">
            <mat-checkbox
              *ngIf="(inputColumns | filterArray:['select','Name']).length == 0 || (inputColumns | filterArray:['select','Name'])[0].Function(row)"
              (click)="$event.stopPropagation()" (change)="onCheckBoxChange(row)" [checked]="isRowSelected(row)"
              [disabled]="!allowEdit && !allowEditCheckBox">
            </mat-checkbox>
          </td>
        </ng-container>
      
      
        <!-- All Columns da Entidade -->
        <ng-container *ngFor="let property of columnsOfObject;" [matColumnDef]="property.ObjectKey">
      
          <!-- Cabecalho da Table -->
          <th mat-header-cell *matHeaderCellDef>
            <ng-container *ngFor="let column of displayedColumns;">
              <strong style="color:black;">
                <div mat-sort-header *ngIf="column.ColumnValue == property.ObjectKey"><div [class.text-right]="property.AlignRight">{{ column.ColumnName }}</div></div>
              </strong>
            </ng-container>
      
            <!-- Filtro da Coluna do Tipo Text -->
            <ng-container [ngSwitch]="property.InputType">
              <div *ngSwitchCase="'text'">
                <mat-form-field class="full-width findInputContainer">
                  <input (keydown.enter)="filter(true)" class="findInput" type="text" matInput placeholder="{{'FILTER'|translate}}"
                    [(ngModel)]="property.FilterValue">
                </mat-form-field>
              </div>

              <div *ngSwitchCase="'combobox'">
                <mat-form-field class="full-width findInputContainer" *ngIf="property.SelectList">
                  <mat-select class="findInput" changeJs placeholder="{{'FILTER'|translate}}" (selectionChange)="filter(true)" [(ngModel)]="property.FilterValue">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let value of property.SelectList"
                      [value]="value.ID?.toString()">
                      {{ value.Name }} </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

              <div *ngSwitchCase="'date'">
                <mat-form-field class="full-width findInputContainer">
                  <input class="one date-picker findInput" type="text" (keydown.enter)="filter(true)"
                    (onChangeDatePicker)="filter(true)" matInput placeholder="{{'FILTER'|translate}}" [(ngModel)]="property.FilterValue"
                    [tipoDateTime]="1">
                  <i matSuffix class="far fa-calendar-alt"></i>
                </mat-form-field>
              </div>

              <div *ngSwitchCase="'number'">
                <mat-form-field class="full-width findInputContainer">
                  <input (keydown.enter)="filter(true)" class="findInput" type="number" matInput placeholder="{{'FILTER'|translate}}"
                    [(ngModel)]="property.FilterValue">
                </mat-form-field>
              </div>

            </ng-container>

          </th>
          <!-- END Cabecalho da Table -->
      
          <!-- Colunas da Table -->
          <td mat-cell *matCellDef="let row; let i = index" 
          [style.max-width]="(inputColumns | filterArray:[property.ObjectKey,'Name']) && (inputColumns | filterArray:[property.ObjectKey,'Name']).length > 0 ? 
              (inputColumns | filterArray:[property.ObjectKey,'Name'])[0].MaxWidth : null">
            <ng-container *ngIf="(inputColumns | filterArray:[property.ObjectKey,'Name']).length != 0; else showValue;">
              <ng-container *ngFor="let item of inputColumns | filterArray:[property.ObjectKey,'Name']">
      
                <ng-container *ngIf="!isFormArray(); else form">
                  <ng-container *ngTemplateOutlet="switchInputTypes"></ng-container>
                </ng-container>
      
                <ng-template #form>
                  <ng-container *ngTemplateOutlet="switchInputTypesForm"></ng-container>
                </ng-template>
      
      
                <ng-template #switchInputTypes>
                  <ng-container [ngSwitch]="item.InputType">
                    
                    <div *ngSwitchCase="'combobox'">
                      <!-- Combobox Com Entidade Externa -->
                      <mat-form-field class="full-width findInputContainer" *ngIf="item.ListOptionsCombobox && !item.ListOptionsCombobox.ListProperty">
                        <mat-select class="findInput" changeJs [(ngModel)]="row[item.Name]" (selectionChange)="onChangeSelectBox.emit({column: item.Name, row: row, event: $event})"
                        [disabled]="item.IsDisabled || row['IsDisabled']">
                          <mat-select-header class="device-select-header">
                            <mat-form-field class="col-sm-12 md-select-search">
                              <input matInput #searchState type="text" placeholder="{{'SEARCH'|translate}}">
                              <i matSuffix class="fas fa-search"></i>
                            </mat-form-field>
                          </mat-select-header>
                          <mat-option></mat-option>
                          <mat-option *ngFor="let value of item.ListOptionsCombobox.List | mdSelectContainsPipe:[item.ListOptionsCombobox.ShowProperty, searchState.value]"
                            [value]="value[item.ListOptionsCombobox.ValueProperty]">
                            {{ value[item.ListOptionsCombobox.ShowProperty] }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                       <!-- END Combobox Com Entidade Externa -->

                      <!-- Combobox Com Propriedade da Entidade  -->
                      <mat-form-field class="full-width findInputContainer" *ngIf="item.ListOptionsCombobox && item.ListOptionsCombobox.ListProperty && row[item.ListOptionsCombobox.ListProperty]">
                        <mat-select class="findInput" changeJs [(ngModel)]="row[item.Name]" (selectionChange)="onChangeSelectBox.emit({column: item.Name, row: row, event: $event})"
                        [disabled]="item.IsDisabled || row['IsDisabled']">
                          <mat-select-header class="device-select-header">
                            <mat-form-field class="col-sm-12 md-select-search">
                              <input matInput #searchState type="text" placeholder="{{'SEARCH'|translate}}">
                              <i matSuffix class="fas fa-search"></i>
                            </mat-form-field>
                          </mat-select-header>
                          <mat-option></mat-option>
                          <mat-option *ngFor="let value of row[item.ListOptionsCombobox.ListProperty] | mdSelectContainsPipe:[item.ListOptionsCombobox.ShowProperty, searchState.value]"
                            [value]="value[item.ListOptionsCombobox.ValueProperty]">
                            {{ value[item.ListOptionsCombobox.ShowProperty] }}
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <!-- END Combobox Com Propriedade da Entidade  -->
                    </div>
      
                    <div class="full-width" *ngSwitchCase="'icons'">
                      <i [ngClass]="[row[property.ObjectKey]]"></i>
                    </div>
      
                    <div class="full-width" [class.text-right]="property.AlignRight" *ngSwitchCase="'function'">
                      {{ item.Function(row[property.ObjectKey],_translateValueService,_dialog,_decimalPipe) }}
                    </div>

                    <div class="full-width" *ngSwitchCase="'route'">
                      <ng-container *ngIf="item.RouteOptions && row['ID']">
                        <a class="table-order-link" [routerLink]="'/'+item.RouteOptions.RouteUrl+'/'+row['ID']" [state]="item.RouteOptions.Params">{{ row[property.ObjectKey] }} </a>
                      </ng-container>
                    </div>

                    <div class="full-width" *ngSwitchCase="'routeClick'">
                      <ng-container *ngIf="row['ID']">
                        <a class="table-order-link pointer" (click)="onRouteClick.emit(row)">{{ row[property.ObjectKey] }}</a>
                      </ng-container>
                    </div>
    
                    <div class="full-width" *ngSwitchCase="'states'">
                      <ng-container *ngIf="item.Function && row['ID']">
                        <div class="table-workflow inline-flex">
                          <a class="btn btn-xs pointer" style="margin: auto 4px auto 0 !important;" (click)="item.Function(row['ID'],_translateValueService,_dialog,_decimalPipe, row, this)"><i data-toggle="tooltip" title="{{ 'STATES_HISTORY' | translate }}" class="fas fa-cogs"></i></a>
                          <span class="margin-vertical-center">{{ row[property.ObjectKey] }}</span>
                        </div>
                      </ng-container>
                    </div>
                    
                    <!-- Input Date -->
                    <div *ngSwitchCase="'date'">
                      <mat-form-field class="full-width">
                        <input class="one date-picker" type="text" matInput [(ngModel)]="row[property.ObjectKey]" [tipoDateTime]="1" [disabled]="row['IsDisabled']">
                        <i matSuffix class="far fa-calendar-alt"></i>
                      </mat-form-field>
                    </div>
      
                    <mat-form-field class="full-width" *ngSwitchDefault>
                      <input matInput *ngIf="!item.BlockNgModel" [type]="item.InputType" (change)="onChangeInput.emit({column: item.Name, row: row, event: $event})"
                        [(ngModel)]="row[property.ObjectKey]"
                        [disabled]="row['IsDisabled']">

                        <input matInput *ngIf="item.BlockNgModel" [type]="item.InputType" 
                        [value]="row[property.ObjectKey]"
                        (change)="onChangeInput.emit({column: item.Name, row: row, event: $event})"
                        [disabled]="row['IsDisabled']">
                    </mat-form-field>
      
                  </ng-container>
                </ng-template>
    
                <ng-template #switchInputTypesForm>
                  <ng-container [ngSwitch]="item.InputType">
      
                    <div *ngSwitchCase="'combobox'">
                      <mat-form-field class="full-width findInputContainer" *ngIf="item.ListOptionsCombobox">
                        <mat-select class="findInput" changeJs [placeholder]="property.ObjectKey">
                          <mat-option></mat-option>
                          <mat-option *ngFor="let value of item.ListOptionsCombobox.List"
                            [value]="value[item.ListOptionsCombobox.ValueProperty]">
                            {{ value[item.ListOptionsCombobox.ShowProperty] }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
      
                    <div class="full-width" *ngSwitchCase="'icons'">
                      <i [ngClass]="[row[property.ObjectKey]]"></i>
                    </div>
      
                    <div class="full-width" [class.text-right]="property.AlignRight" *ngSwitchCase="'function'">
                      {{ item.Function(row[property.ObjectKey]) }}
                    </div>
      
                    <mat-form-field class="full-width" *ngSwitchDefault>
                      <input matInput [type]="item.InputType" (change)="onChangeInput.emit({column: item.Name, row: row, event: $event})"
                      [formControlName]="property.ObjectKey">
                    </mat-form-field>
                    <error [control]="getFormControl(i,property.ObjectKey)"></error>
      
                  </ng-container>
                </ng-template>
      
      
                <ng-template #otherInput></ng-template>
      
              </ng-container>
            </ng-container>
      
            <ng-template #showValue>
              <div [class.text-right]="property.AlignRight">
                {{row[property.ObjectKey]}}
              </div>
            </ng-template>
          </td>
          <!-- END Colunas da Table -->
      
      
          <!-- Footer da Table -->
          <ng-container *ngIf="footerRows && footerRows.length">
            <ng-container *ngFor="let footerRow of footerRows; index as i">
              <ng-container *ngFor="let footerColumn of footerRow.FooterColumns; index as y"
                [matColumnDef]="footerColumn.FooterColumnName">
                <!-- Footer não atualiza se não for feito desta forma -->
                <td mat-footer-cell *matFooterCellDef class="align-center pr-8"
                  [innerHTML]="footerRows[i]?.FooterColumns[y]?.Value"
                  [attr.colspan]="footerColumn.Colspan"></td>
              </ng-container>
            </ng-container>
          </ng-container>
          <!-- END Footer da Table -->
      
        </ng-container>
      
        <!-- Generic Column -->
        <ng-container matColumnDef="generic">
          <ng-container *ngTemplateOutlet="genericColumn"></ng-container>
        </ng-container>

        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="w-75">
            <div style="display: flex;" *ngIf="!hideHeaderActions">
              <button type="button" class="btn btn-sm btn-primary no-margin-bottom"
                (click)="filter(true)">{{'FILTER'|translate}}</button>
              <button type="button" class="btn btn-sm btn-default no-margin-bottom"
                (click)="clearFilters()">{{'BUTTON.CLEAR'|translate}}</button>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="w-75">
            <div style="display: flex; justify-content: center;">
              <div *ngIf="allowEdit || (inputColumns | filterArray:['actions','Name']).length != 0 && (inputColumns | filterArray:['actions','Name'])[0].Function(row).edit; else view">
                  <a class="btn btn-sm table-edit" (click)="edit(row)"><span title="{{'BUTTON.EDIT'|translate}}"><i
                    class="fas fa-pencil-alt color-warning backwhite"></i></span></a>
              </div>
           
              <ng-template #view>
                <a *ngIf="allowView" class="btn btn-sm table-edit" (click)="edit(row)"><span title="{{'BUTTON.CONSULT'|translate}}"><i
                      class="fas fa-search-plus color-primary backwhite"></i></span></a>
              </ng-template>
      
              <div *ngIf="allowDelete || (inputColumns | filterArray:['actions','Name']).length != 0 && (inputColumns | filterArray:['actions','Name'])[0].Function(row).delete">
                  <a class="btn btn-sm table-delete" (click)="delete(row)"><span title="{{'BUTTON.DELETE'|translate}}"><i
                    class="far fa-trash-alt color-danger backwhite"></i></span></a>            
              </div>


           

              <div *ngIf="allowExport">
                <a class="btn btn-sm table-export" (click)="export(row)">
                  <span><i class="far fa-file-pdf color-danger backwhite"></i></span>
                </a>            
              </div>

              <ng-container *ngIf="extraActions">
                <ng-container *ngTemplateOutlet="extraActions; context: {$implicit : row}"></ng-container>
              </ng-container>
            </div>
          </td>
        </ng-container>
      
        <!-- NO Data Row -->
        <ng-container matColumnDef="empty-row">
          <td mat-cell *matCellDef="let data; let i = index" [attr.colspan]="this.displayedColumns.length">
            <div class="small" style="display: flex; justify-content: center; padding-top: 5px;">
              {{'NO_RESULTS_DT'|translate}}
            </div>
          </td>
        </ng-container>
    
    
        <tr mat-header-row *matHeaderRowDef="columnsValues"></tr>
        <tr mat-row
          *matRowDef="let row; columns: dataSource && dataSource.data.length > 0 && dataSource.filteredData.length > 0 ? columnsValues : ['empty-row'];">
        </tr>
    
        <!-- Footer -->
        <ng-container *ngIf="footerRows && footerRows.length">
          <ng-container *ngFor="let footerRow of footerRows">
            <tr mat-footer-row *matFooterRowDef="footerRow.ColumsOrder"></tr>
          </ng-container>
        </ng-container>
      
      </table>
  </ng-container>
  
  <ng-template #formTable>

    <div [formGroup]="form">
      <table mat-table
        [dataSource]="dataSource && dataSource.data.length > 0 && dataSource.filteredData.length > 0 ? dataSource : emptyData"
        matSort class="table table-bordered display" [formArrayName]="formGroup ? formArrayName :'array'">
      
        <!-- CheckBox Columns -->
        <ng-container matColumnDef="select">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox #headerCheckbox
              *ngIf="showSelectAllCheckbox"
              (change)="$event ? masterToggle($event) : null"
              [indeterminate]="alreadySelectedRows.alreadySelectedKeys?.length > 0 && alreadySelectedRows.alreadySelectedKeys?.length != paginator.length" 
              [disabled]="!allowEdit && !allowEditCheckBox">
            </mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let row">
            <mat-checkbox (click)="$event.stopPropagation()" (change)="onCheckBoxChange(row)"
              [checked]="isRowSelected(row)">
            </mat-checkbox>
          </td>
        </ng-container>
      
      
        <!-- All Columns da Entidade -->
        <ng-container *ngFor="let property of columnsOfObject;" [matColumnDef]="property.ObjectKey">
      
          <!-- Cabecalho da Table -->
          <th mat-header-cell *matHeaderCellDef>
            <ng-container *ngFor="let column of displayedColumns;">
              <strong style="color: black">
                <div mat-sort-header *ngIf="column.ColumnValue == property.ObjectKey"><div [class.text-right]="property.AlignRight">{{ column.ColumnName }}</div></div>
              </strong>
            </ng-container>
      
            <!-- Filtro da Coluna do Tipo Text -->
            <ng-container [ngSwitch]="property.InputType">

              <div *ngSwitchCase="'text'">
                <mat-form-field class="full-width findInputContainer">
                  <input (keydown.enter)="filter(true)" class="findInput" type="text" matInput placeholder="{{'FILTER'|translate}}"
                    [(ngModel)]="property.FilterValue" [ngModelOptions]="{ standalone: true }">
                </mat-form-field>
              </div>

              <div *ngSwitchCase="'date'">
                <mat-form-field class="full-width findInputContainer">
                  <input class="one date-picker findInput" type="text" (keydown.enter)="filter(true)"
                    (onChangeDatePicker)="filter(true)" matInput placeholder="{{'FILTER'|translate}}" [(ngModel)]="property.FilterValue"
                    [tipoDateTime]="1" [ngModelOptions]="{ standalone: true }">
                  <i matSuffix class="far fa-calendar-alt"></i>
                </mat-form-field>
              </div>

              <!-- Select -->
              <div *ngSwitchCase="'combobox'">
                <mat-form-field class="full-width findInputContainer" *ngIf="property.SelectList">
                  <mat-select class="findInput" changeJs placeholder="{{'FILTER'|translate}}" (selectionChange)="filter(true)" [(ngModel)]="property.FilterValue"
                  [ngModelOptions]="{ standalone: true }">
                    <mat-option></mat-option>
                    <mat-option *ngFor="let value of property.SelectList"
                      [value]="value.ID">
                      {{ value.Name }}</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>

            </ng-container>
          </th>
          <!-- END Cabecalho da Table -->
      
          <!-- Colunas da Table -->
          <td mat-cell *matCellDef="let row; let i = index" [formGroupName]="i">
            <ng-container *ngIf="(inputColumns | filterArray:[property.ObjectKey,'Name']).length != 0; else showValue;">
              <ng-container *ngFor="let item of inputColumns | filterArray:[property.ObjectKey,'Name']">
      
                <ng-container *ngIf="!isFormArray(); else form">
                  <ng-container *ngTemplateOutlet="switchInputTypes"></ng-container>
                </ng-container>
      
                <ng-template #form>
                  <ng-container *ngTemplateOutlet="switchInputTypesForm"></ng-container>
                </ng-template>
      
      
                <ng-template #switchInputTypes>
                  <ng-container [ngSwitch]="item.InputType">
                    <div *ngSwitchCase="'combobox'">
                      <mat-form-field class="full-width findInputContainer" *ngIf="item.ListOptionsCombobox">
                        <mat-select class="findInput" changeJs>
                          <mat-option></mat-option>
                          <mat-option *ngFor="let value of item.ListOptionsCombobox.List"
                            [value]="value[item.ListOptionsCombobox.ValueProperty]">
                            {{ value[item.ListOptionsCombobox.ShowProperty] }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>
      
                    <div class="full-width" *ngSwitchCase="'icons'">
                      <i [ngClass]="[row[property.ObjectKey]]"></i>
                    </div>
      
                    <div class="full-width" [class.text-right]="property.AlignRight" *ngSwitchCase="'function'">
                      {{ item.Function(row[property.ObjectKey],_translateValueService,_dialog,_decimalPipe) }}
                    </div>

                    <div class="full-width" *ngSwitchCase="'route'">
                      <ng-container *ngIf="item.RouteUrl && row['ID']">
                        <a class="table-order-link" [href]="'/'+item.RouteUrl+'/'+row['ID']">{{ row[property.ObjectKey] }} </a>
                      </ng-container>
                    </div>

                    <div class="full-width" *ngSwitchCase="'routeClick'">
                      <ng-container *ngIf="row['ID']">
                        <a class="table-order-link pointer" (click)="onRouteClick.emit(row)">{{ row[property.ObjectKey] }}</a>
                      </ng-container>
                    </div>
    
                    <div class="full-width" *ngSwitchCase="'states'">
                      <ng-container *ngIf="item.Function && row['ID']">
                        <div class="table-workflow inline-flex">
                          <a class="btn btn-xs pointer" style="margin: auto 4px auto 0 !important;" (click)="item.Function(row['ID'],_translateValueService,_dialog, null, row, this)"><i data-toggle="tooltip" title="{{ 'STATES_HISTORY' | translate }}" class="fas fa-cogs"></i></a>
                          <span class="margin-vertical-center">{{ row[property.ObjectKey] }}</span>
                        </div>
                      </ng-container>
                    </div>
      
                    <mat-form-field class="full-width" *ngSwitchDefault>
                      <input matInput [type]="item.InputType"
                        [(ngModel)]="row[property.ObjectKey]">
                    </mat-form-field>
      
                  </ng-container>
                </ng-template>
    
                <ng-template #switchInputTypesForm>
                  <ng-container [ngSwitch]="item.InputType">
      
                    <div *ngSwitchCase="'combobox'">
                      <mat-form-field class="full-width findInputContainer" *ngIf="item.ListOptionsCombobox">
                        <mat-select class="findInput" changeJs>
                          <mat-option></mat-option>
                          <mat-option *ngFor="let value of item.ListOptionsCombobox.List"
                            [value]="value[item.ListOptionsCombobox.ValueProperty]">
                            {{ value[item.ListOptionsCombobox.ShowProperty] }}</mat-option>
                        </mat-select>
                      </mat-form-field>
                    </div>

            <!--         <div class="full-width" *ngSwitchCase="'route'">
                      <ng-container *ngIf="item.RouteOptions && row['ID']">
                        <a class="table-order-link" [routerLink]="'/'+item.RouteOptions.RouteUrl+'/'+row['ID']" [state]="item.RouteOptions.Params">{{ row[property.ObjectKey] }} </a>
                      </ng-container>
                    </div>
    
                    <div class="full-width" *ngSwitchCase="'states'">
                      <ng-container *ngIf="item.Function && row['ID']">
                        <div class="table-workflow inline-flex">
                          <a class="btn btn-xs pointer" style="margin: auto 4px auto 0 !important;" (click)="item.Function(row['ID'],_translateValueService,_dialog,_decimalPipe)"><i data-toggle="tooltip" title="{{ 'STATES_HISTORY' | translate }}" class="fas fa-cogs"></i></a>
                          <span class="margin-vertical-center">{{ row[property.ObjectKey] }}</span>
                        </div>
                      </ng-container>
                    </div> -->
      
                    <div class="full-width" *ngSwitchCase="'icons'">
                      <i [ngClass]="[row[property.ObjectKey]]"></i>
                    </div>
      
                    <div class="full-width" *ngSwitchCase="'function'">
                      {{ item.Function(row[property.ObjectKey]) }}
                    </div>

                    <ng-container *ngSwitchCase="'number'">
                      <mat-form-field class="full-width" >
                        <input matInput [type]="item.InputType" [formControlName]="property.ObjectKey">
                      </mat-form-field>
                      <error [control]="getFormControl(i,property.ObjectKey)"></error>
                    </ng-container>

                    <!-- Input Date -->
                    <div *ngSwitchCase="'date'">
                      <mat-form-field class="full-width">
                        <input class="one date-picker" type="text" matInput [formControlName]="property.ObjectKey" [tipoDateTime]="1" >
                        <i matSuffix class="far fa-calendar-alt"></i>
                      </mat-form-field>
                      <error [control]="getFormControl(i,property.ObjectKey)"></error>
                    </div>
                    
                    <ng-container *ngSwitchCase="'numberFormat'">
                      <mat-form-field class="full-width">
                        <input matInput format [type]="item.InputType" [formControlName]="property.ObjectKey">
                      </mat-form-field>
                      <error [control]="getFormControl(i,property.ObjectKey)"></error>
                    </ng-container>

                    <ng-container *ngSwitchDefault>
                      <mat-form-field class="full-width">
                        <input matInput [type]="item.InputType"
                        [formControlName]="property.ObjectKey">
                      </mat-form-field>
                      <error [control]="getFormControl(i,property.ObjectKey)"></error>
                    </ng-container>
      

                  </ng-container>
                </ng-template>
      
      
                <ng-template #otherInput></ng-template>
      
              </ng-container>
            </ng-container>
      
            <ng-template #showValue>
              <div class="mat-cell-value" [class.text-right]="property.AlignRight">
                {{row[property.ObjectKey]}}
              </div>
            </ng-template>
          </td>
          <!-- END Colunas da Table -->
      
      
          <!-- Footer da Table -->
          <ng-container *ngIf="footerRows && footerRows.length">
            <ng-container *ngFor="let footerRow of footerRows">
              <ng-container *ngFor="let footerColumn of footerRow.FooterColumns"
                [matColumnDef]="footerColumn.FooterColumnName">
                <td mat-footer-cell *matFooterCellDef
                  [innerHTML]="footerColumn && footerColumn.Value ? footerColumn.Value :  ''"
                  [attr.colspan]="footerColumn.Colspan"></td>
              </ng-container>
            </ng-container>
          </ng-container>
          <!-- END Footer da Table -->
      
        </ng-container>
      
        <!-- Generic Column -->
        <ng-container matColumnDef="generic">
          <ng-container *ngTemplateOutlet="genericColumn"></ng-container>
        </ng-container>
      
      
        <!-- Actions Column -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell *matHeaderCellDef class="w-75">
            <div style="display: flex;">
              <button type="button" class="btn btn-sm btn-primary no-margin-bottom"
                (click)="filter(true)">{{'FILTER'|translate}}</button>
              <button type="button" class="btn btn-sm btn-default no-margin-bottom"
                (click)="clearFilters()">{{'BUTTON.CLEAR'|translate}}</button>
            </div>
          </th>
          <td mat-cell *matCellDef="let row" class="w-75">
            <div style="display: flex; justify-content: center;">
              <div *ngIf="allowEdit || (inputColumns | filterArray:['actions','Name']).length != 0 && (inputColumns | filterArray:['actions','Name'])[0].Function(row).edit; else view">
                  <a class="btn btn-sm table-edit" (click)="edit(row)"><span title="{{'BUTTON.EDIT'|translate}}"><i
                    class="fas fa-pencil-alt color-warning backwhite"></i></span></a>
              </div>
            
              <ng-template #view>
                <a *ngIf="allowView" class="btn btn-sm table-edit" (click)="edit(row)"><span title="{{'BUTTON.CONSULT'|translate}}"><i
                      class="fas fa-search-plus color-primary backwhite"></i></span></a>
              </ng-template>
      
              <div *ngIf="allowDelete || (inputColumns | filterArray:['actions','Name']).length != 0 && (inputColumns | filterArray:['actions','Name'])[0].Function(row).delete">
                  <a class="btn btn-sm table-delete" (click)="delete(row)"><span title="{{'BUTTON.DELETE'|translate}}"><i
                    class="far fa-trash-alt color-danger backwhite"></i></span></a>            
              </div>
            </div>
          </td>
        </ng-container>
      
        <!-- NO Data Row -->
        <ng-container matColumnDef="empty-row">
          <td mat-cell *matCellDef="let data; let i = index" [attr.colspan]="this.displayedColumns.length">
            <div class="small" style="display: flex; justify-content: center; padding-top: 5px;">
              {{'NO_RESULTS_DT'|translate}}
            </div>
          </td>
        </ng-container>
    
    
        <tr mat-header-row *matHeaderRowDef="columnsValues"></tr>
        <tr mat-row
          *matRowDef="let row; columns: dataSource && dataSource.data.length > 0 && dataSource.filteredData.length > 0 ? columnsValues : ['empty-row'];">
        </tr>
    
        <!-- Footer -->
        <ng-container *ngIf="footerRows && footerRows.length">
          <ng-container *ngFor="let footerRow of footerRows">
            <tr mat-footer-row *matFooterRowDef="footerRow.ColumsOrder"></tr>
          </ng-container>
        </ng-container>
      
        </table>
    </div>

  </ng-template>
  
  

</ng-template>
<!-- END Normal Table -->

<!--Table Expandable -->
<ng-template #tableExpandable>
  <table mat-table [dataSource]="dataSource" matSort class="table table-bordered display" multiTemplateDataRows>

    <!-- Expand Columns (Icons) -->
    <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row" (click)="expandedElement = expandedElement == row ? null : row">
        <i [class]="row != expandedElement ? 'fas fa-plus pointer' : 'fas fa-minus pointer'" aria-hidden="true"></i>
      </td>
    </ng-container>

    <!-- CheckBox Columns -->
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox #headerCheckbox
          *ngIf="showSelectAllCheckbox"
          (change)="$event ? masterToggle($event) : null"
          [indeterminate]="alreadySelectedRows.alreadySelectedKeys?.length > 0 && alreadySelectedRows.alreadySelectedKeys?.length != paginator.length" 
          [disabled]="!allowEdit && !allowEditCheckBox">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()" (change)="onCheckBoxChange(row)"
          [checked]="isRowSelected(row)">
        </mat-checkbox>
      </td>
    </ng-container>
  
  
    <!-- All Columns da Entidade -->
    <ng-container *ngFor="let property of columnsOfObject;" [matColumnDef]="property.ObjectKey">
  
      <!-- Cabecalho da Table -->
      <th mat-header-cell *matHeaderCellDef>
        <ng-container *ngFor="let column of displayedColumns;">
          <strong style="color: black;">
            <div mat-sort-header *ngIf="column.ColumnValue == property.ObjectKey"><div [class.text-right]="property.AlignRight">{{ column.ColumnName }}</div></div>
          </strong>
        </ng-container>
  
        <!-- Filtro da Coluna do Tipo Text -->
        <ng-container [ngSwitch]="property.InputType">
          <div *ngSwitchCase="'text'">
            <mat-form-field class="full-width findInputContainer">
              <input changeJs (keydown.enter)="filter(true)" class="findInput" type="text" matInput placeholder="{{'FILTER'|translate}}"
                [(ngModel)]="property.FilterValue">
            </mat-form-field>
          </div>

          <div *ngSwitchCase="'date'">
            <mat-form-field class="full-width findInputContainer">
              <input class="one date-picker findInput" type="text" (keydown.enter)="filter(true)"
                (onChangeDatePicker)="filter(true)" matInput placeholder="{{'FILTER'|translate}}" [(ngModel)]="property.FilterValue"
                [tipoDateTime]="1">
              <i matSuffix class="far fa-calendar-alt"></i>
            </mat-form-field>
          </div>

          <div *ngSwitchCase="'combobox'">
            <mat-form-field class="full-width findInputContainer" *ngIf="property.SelectList">
              <mat-select class="findInput" changeJs placeholder="{{'FILTER'|translate}}" (selectionChange)="filter(true)" [(ngModel)]="property.FilterValue">
                <mat-option></mat-option>
                <mat-option *ngFor="let value of property.SelectList"
                  [value]="value.ID">
                  {{ value.Name }}</mat-option>
              </mat-select>
            </mat-form-field>
          </div>

        </ng-container>
      </th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="(inputColumns | filterArray:[property.ObjectKey,'Name']).length != 0; else showValue;">
          <ng-container *ngFor="let item of inputColumns | filterArray:[property.ObjectKey,'Name']">
  
            <ng-container *ngIf="!item.form; else form">
              <ng-container *ngTemplateOutlet="switchInputTypes"></ng-container>
            </ng-container>
  
            <ng-template #form>
              <ng-container *ngTemplateOutlet="switchInputTypes"></ng-container>
            </ng-template>
  
  
            <ng-template #switchInputTypes>
              <ng-container [ngSwitch]="item.InputType">
  
                <div *ngSwitchCase="'combobox'">
                  <mat-form-field class="full-width findInputContainer" *ngIf="item.ListOptionsCombobox">
                    <mat-select class="findInput" changeJs [placeholder]="property.ObjectKey">
                      <mat-option></mat-option>
                      <mat-option *ngFor="let value of item.ListOptionsCombobox.List"
                        [value]="value[item.ListOptionsCombobox.ValueProperty]">
                        {{ value[item.ListOptionsCombobox.ShowProperty] }}</mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
  
                <div class="full-width" *ngSwitchCase="'icons'">
                  <i [ngClass]="[row[property.ObjectKey]]"></i>
                </div>
                
                <div class="full-width" [class.text-right]="property.AlignRight" *ngSwitchCase="'function'">
                  {{ item.Function(row[property.ObjectKey],_translateValueService,_dialog,_decimalPipe) }}
                </div>
                
                <div class="full-width" *ngSwitchCase="'custom'">
                  <ng-container *ngIf="item.CustomTemplate">
                    <ng-container *ngTemplateOutlet="item.CustomTemplate; context: {$implicit : row, index: i}"></ng-container>
                  </ng-container>
                </div>

                <div class="full-width" *ngSwitchCase="'route'">
                  <ng-container *ngIf="item.RouteOptions && row['ID']">
                    <a class="table-order-link" [routerLink]="'/'+item.RouteOptions.RouteUrl+'/'+row['ID']" [state]="item.RouteOptions.Params">{{ row[property.ObjectKey] }} </a>
                  </ng-container>
                </div>

                <div class="full-width" *ngSwitchCase="'routeClick'">
                  <ng-container *ngIf="row['ID']">
                    <a class="table-order-link pointer" (click)="onRouteClick.emit(row)">{{ row[property.ObjectKey] }}</a>
                  </ng-container>
                </div>

                <div class="full-width" *ngSwitchCase="'states'">
                  <ng-container *ngIf="item.Function && row['ID']">
                    <div class="table-workflow inline-flex">
                      <a class="btn btn-xs pointer" style="margin: auto 4px auto 0 !important;" (click)="item.Function(row['ID'],_translateValueService,_dialog,_decimalPipe, row, this)"><i data-toggle="tooltip" title="{{ 'STATES_HISTORY' | translate }}" class="fas fa-cogs"></i></a>
                      <span class="margin-vertical-center">{{ row[property.ObjectKey] }}</span>
                    </div>
                  </ng-container>
                </div>

                <!-- Input Date -->
                <div *ngSwitchCase="'date'">
                  <mat-form-field class="full-width">
                    <input class="one date-picker" type="text" matInput [(ngModel)]="row[property.ObjectKey]" [tipoDateTime]="1">
                    <i matSuffix class="far fa-calendar-alt"></i>
                  </mat-form-field>
                </div>
                
                <mat-form-field class="full-width" *ngSwitchDefault>
                  <input matInput [type]="item.InputType" [placeholder]="property.ObjectKey"
                    [(ngModel)]="row[property.ObjectKey]">
                </mat-form-field>
  
              </ng-container>
            </ng-template>
  
  
            <ng-template #otherInput></ng-template>
  
          </ng-container>
        </ng-container>
  
        <ng-template #showValue>
          <div [class.text-right]="property.AlignRight">
            {{row[property.ObjectKey]}}
          </div>
        </ng-template>
      </td>
      <!-- END Colunas da Table -->
  
  
      <!-- Footer da Table -->
      <ng-container *ngIf="footerRows && footerRows.length">
        <ng-container *ngFor="let footerRow of footerRows">
          <ng-container *ngFor="let footerColumn of footerRow.FooterColumns"
            [matColumnDef]="footerColumn.FooterColumnName">
            <td mat-footer-cell *matFooterCellDef
              [innerHTML]="footerColumn && footerColumn.Value ? footerColumn.Value :  ''"
              [attr.colspan]="footerColumn.Colspan"></td>
          </ng-container>
        </ng-container>
      </ng-container>
      <!-- END Footer da Table -->
  
    </ng-container>
  
    <!-- Generic Column -->
    <ng-container matColumnDef="generic">
      <ng-container *ngTemplateOutlet="genericColumn"></ng-container>
    </ng-container>
  
  
    <!-- Actions Column -->
    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef class="w-75">
        <div style="display: flex;">
          <button type="button" class="btn btn-sm btn-primary no-margin-bottom"
            (click)="filter(true)">{{'FILTER'|translate}}</button>
          <button type="button" class="btn btn-sm btn-default no-margin-bottom"
            (click)="clearFilters()">{{'BUTTON.CLEAR'|translate}}</button>
        </div>
      </th>
      <td mat-cell *matCellDef="let row" class="w-75">
        <div style="display: flex; justify-content: center;">
          <div *ngIf="allowEdit || (inputColumns | filterArray:['actions','Name']).length != 0 && (inputColumns | filterArray:['actions','Name'])[0].Function(row).edit; else view">
              <a class="btn btn-sm table-edit" (click)="edit(row)"><span title="{{'BUTTON.EDIT'|translate}}"><i
                class="fas fa-pencil-alt color-warning backwhite"></i></span></a>
          </div>
          <div *ngIf="allowExportSEPA && !(inputColumns | filterArray:['actions','Name']).length != 0 || !(inputColumns | filterArray:['actions','Name'])[0].Function(row).edit">
            <a class="btn btn-sm table-export-SEPA" (click)="exportSEPAClick(row)"><span title="{{'BUTTON.EXPORT_SEPA'|translate}}"><i
              class="fas fa-download color-success backwhite"></i></span></a>            
          </div>
          <ng-template #view>
            <a  class="btn btn-sm table-edit" (click)="edit(row)"><span title="{{'BUTTON.CONSULT'|translate}}"><i
                  class="fas fa-search-plus color-primary backwhite"></i></span></a>
          </ng-template>
  
          <div *ngIf="allowDelete || (inputColumns | filterArray:['actions','Name']).length != 0 && (inputColumns | filterArray:['actions','Name'])[0].Function(row).delete">
              <a class="btn btn-sm table-delete" (click)="delete(row)"><span title="{{'BUTTON.DELETE'|translate}}"><i
                class="far fa-trash-alt color-danger backwhite"></i></span></a>            
          </div>
        </div>
      </td>
    </ng-container>
  
    <!-- NO Data Row -->
    <ng-container matColumnDef="empty-row">
      <td mat-cell *matCellDef="let data; let i = index" [attr.colspan]="this.displayedColumns.length">
        <div class="small" style="display: flex; justify-content: center; padding-top: 5px;">
          {{'NO_RESULTS_DT'|translate}}
        </div>
      </td>
    </ng-container>


    <!-- Coluna que Tem o conteudo que expande realizado com base em CSS -->
    <ng-container matColumnDef="expandedDetail">
      <td mat-cell *matCellDef="let row" [attr.colspan]="columnsValues.length" class="element-row-detail">
        <div class="element-detail" [@detailExpand]="row == expandedElement ? 'expanded' : 'collapsed'">
          <ng-container *ngTemplateOutlet="expandableContent; context: {$implicit : row}"></ng-container>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsValues"></tr>

    <!-- Expandable Table Rows -->
    <tr mat-row *matRowDef="let row; columns: columnsValues;" class="element-row"
      [class.expanded-row]="expandedElement == row">
    </tr>
    <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>

  </table>
</ng-template>
<!--END Table Expandable -->